<template>
  <a-drawer
    :title="title"
    :width="drawerWidth"
    @close="handleCancel"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :wrapStyle="{height: '100%',overflow: 'auto'}"
  >
    <div :style="{width: '100%',border: '1px solid #e9e9e9',padding: '10px 16px',background: '#fff',}">
      <a-spin :spinning="confirmLoading">
        
        <a-form :form="form">
          <a-form-item
            label="菜单名称"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            hasFeedback >
            <a-input placeholder="请输入菜单名称" v-decorator="[ 'name', validatorRules.title]" :readOnly="disableSubmit"/>
          </a-form-item>

          <a-form-item
            label="上级菜单"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol" >
            <a-tree-select
              allowClear
              showSearch
              style="width:100%"
              :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
              :treeData="treeData"
              :value="selectedParent"
              placeholder="请选择父级菜单"
              treeNodeFilterProp="title"
              treeDefaultExpandAll
              @change="onChangeParentMenu"
              :disabled="disableSubmit">
            </a-tree-select>
          </a-form-item>

          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="菜单路径">
            <a-input placeholder="请输入菜单路径" v-decorator="[ 'url',{}]" :readOnly="disableSubmit"/>
          </a-form-item>

          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="备注">
            <a-input placeholder="请输入备注" v-decorator="[ 'description',{}]" :readOnly="disableSubmit"/>
          </a-form-item>

          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="菜单图标">
            <a-input placeholder="点击右侧按钮选择图标" v-model="model.ico" :readOnly="disableSubmit">
              <a-icon slot="addonAfter" type="setting" @click="selectIcons" :title="editIconTitle" />
            </a-input>
          </a-form-item>

          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="排序">
            <a-input-number placeholder="请输入菜单排序" style="width: 200px" v-decorator="[ 'orderCode', {'initialValue':1.0,'rule':validatorRules.sortNo}]" :readOnly="disableSubmit"/>
          </a-form-item>

          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="启用">
            <a-switch checkedChildren="是" unCheckedChildren="否" v-model="enable"/>
          </a-form-item>

        </a-form>

        <!-- 选择图标 -->
        <a-modal v-model="showIcon" title="选择菜单图标" @ok="iconOk" :mask='false' okText="确认" cancelText="取消" :width="900" :centered="true">
          <a-row :gutter="16">
            <a-col class="icon-row" :span="2" v-for="item in iconList" :key="item" :class="selectIcon==item?'icon-ac':''">
              <i :class="'iconfont '+item" @click="clickIcon(item)"></i>
            </a-col>
          </a-row>
        </a-modal>
        <!-- <icons @choose="handleIconChoose" @close="handleIconCancel" :iconChooseVisible="iconChooseVisible"></icons> -->
      </a-spin>
      <a-row :style="{textAlign:'right'}">
        <a-button :style="{marginRight: '8px'}" @click="handleCancel">
          关闭
        </a-button>
        <a-button :disabled="disableSubmit" @click="handleOk" type="primary">确定</a-button>
      </a-row>
    </div>
  </a-drawer>
</template>

<script>
import { addPermission, updatePermission } from '@/baseAPI/memuSetting'
import icon from '@/assets/js/icon.json'
// import Icons from './icon/Icons'
import pick from 'lodash.pick'

export default {
  name: 'PermissionModal',
  // components: { Icons },
  data () {
    return {
      drawerWidth: 700,
      treeData: [],
      title: '操作',
      visible: false,
      disableSubmit: false,
      model: {},
      enable: true,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },

      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        title: { rules: [{ required: true, message: '请输入菜单标题!' }] },
        sortNo: { rules: [{ validator: this.validateNumber }] }
      },
      iconChooseVisible: false,
      selectedParent: null,
      editIconTitle: '',
      iconList:icon,
      showIcon:false,
      selectIcon:''
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    clickIcon(text)
    {
      this.selectIcon=text;
    },
    iconOk()
    {
      this.showIcon=false;
      this.model.ico=this.selectIcon;
      this.form.ico = this.selectIcon;
    },
    add (treeData) {
      this.edit(null, treeData)
    },
    edit (record, treeData) {
      this.treeData = treeData
      this.resetScreenSize() // 调用此方法,根据屏幕宽度自适应调整抽屉的宽度
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.enable = this.model.enable !== undefined ? this.model.enable : true
      this.selectedParent = this.model.parentId === '0' ? null : this.model.parentId
      this.visible = true
      // this.loadTree()
      const fieldsVal = pick(this.model, 'name', 'url', 'description', 'orderCode')
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldsVal)
      })
    },
    close () {
      this.disableSubmit = false
      this.visible = false
    },
    handleOk () {
      const _this = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          _this.confirmLoading = true
          _this.model.parentId = _this.selectedParent
          _this.model.enable = this.enable
          // _this.model.route = this.routeSwitch ? 1 : 0
          const formData = Object.assign(this.model, values)
          let obj
          if (!_this.model.id) {
            obj = addPermission(formData)
          } else {
            const formData1 = pick(formData,'id','parentId','name', 'url','ico','description', 'orderCode','enable')
            obj = updatePermission(formData1)
          }
          obj.then(res => {
              if(res.data.success){
                _this.$notification.success({
                  message: '提示',
                  description: res.message || '操作成功',
                  duration: 3
                })
              } else {
                _this.$notification.error({
                  message: '错误',
                  description: res.data.errorMessage || '操作失败',
                  duration: 3
                })
              }
            // _this.form.resetFields()
            _this.$emit('ok')
          }).catch(err => {
            console.log('err:', err.response)
            _this.$notification.error({ message: '错误', description: err.response.data.message, duration: 3 })
          }).finally(() => {
            _this.confirmLoading = false
            _this.close()
          })
        }
      })
    },
    handleCancel () {
      this.close()
    },
    validateNumber (rule, value, callback) {
      if (!value || new RegExp(/^[0-9]*[1-9][0-9]*$/).test(value)) {
        callback()
      } else {
        callback(new Error('请输入正整数!'))
      }
    },
    selectIcons () {
      this.selectIcon=this.model.ico
      this.showIcon = true
    },
    handleIconCancel () {
      this.iconChooseVisible = false
    },
    handleIconChoose (value) {
      console.log(value)
      this.model.ico = value
      this.form.ico = value
      this.iconChooseVisible = false
    },
    // 根据屏幕变化,设置抽屉尺寸
    resetScreenSize () {
      const screenWidth = document.body.clientWidth
      if (screenWidth < 500) {
        this.drawerWidth = screenWidth
      } else {
        this.drawerWidth = 700
      }
    },
    onChangeParentMenu (value) {
      this.selectedParent = value
    }
  }
}
</script>

<style scoped>
  .icon-row
  {
    display: block;
    text-align: center;
    margin: 1rem 0;
  }
  .iconfont
  {
    font-size: 2rem;
    cursor: pointer;
  }
  .icon-ac
  {
    color: #40a9ff;
  }
</style>
